module.exports = __webpack_public_path__ + "static/media/paulinho.d1d13cb2.jpeg";